<template>
<List
  :heading="heading"
  :description="description"
  model="manufacturer"
  :items="manufacturers"
  :status="status"
  :nextUrl="nextUrl"
  :displayStyle="displayStyle"
  @onFetchMore="updateItems"
>
  <template #filter>
    <p>Total: {{total}} {{plural('manufacturer', total)}}</p>
    <ViewToggle :displayStyle="displayStyle" @toggled="toggleDisplayStyle" />
    <div class="button-holder sort-list">
      <SortToggle
        field="name"
        :activeField="sort.field"
        :direction="sort.direction"
        buttonLabel="Manufacturer Name"
        @sorted="toggleSort"
      />
      <SortToggle
        field="num_groupings"
        :activeField="sort.field"
        :direction="sort.direction"
        buttonLabel="Number Groupings"
        @sorted="toggleSort"
      />
      <SortToggle
        field="num_ponies"
        :activeField="sort.field"
        :direction="sort.direction"
        buttonLabel="Number Ponies"
        @sorted="toggleSort"
      />
    </div>
  </template>
  <template #list>
    <ul class="item-list">
      <ItemListHeader>
        <span>Name:</span>
        <span>Number Groupings:</span>
        <span>Number Ponies:</span>
      </ItemListHeader>
      <ListItem
        @removed="removeItem"
        :key="item.slug"
        v-for="item in manufacturers"
        :item="item"
        :user="user"
        model="manufacturer"
        :url="url(item.slug)"
      >
        <span><router-link :to="`/manufacturer/${item.slug}`">{{item.name}}</router-link></span>
        <span>{{item.num_groupings}} {{plural('Grouping')}}</span>
        <span>{{item.num_ponies}} {{plural('Ponies')}}</span>
      </ListItem>
    </ul>
  </template>
  <ManufacturerCard
    :key="item.slug"
    v-for="item in manufacturers"
    :user="user"
    :item="item"
    @removed="removeItem"
  />
</List>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import List from '../../layouts/List/List';
import ManufacturerCard from '../../components/ManufacturerCard/ManufacturerCard';
import { plural } from '../../utils/helpers';
import { num } from '../../data/config';
import ViewToggle from '../../components/ViewToggle/ViewToggle';
import ListItem from '../../components/ListItem/ListItem';
import SortToggle from '../../components/SortToggle/SortToggle';
import ItemListHeader from '../../components/ItemListHeader/ItemListHeader';

export default {
  name: 'ManufacturerList',
  data() {
    return {
      errors: []
    };
  },
  components: {
    ManufacturerCard,
    List,
    ItemListHeader,
    ListItem,
    SortToggle,
    ViewToggle,
  },
  mounted() {
    if (this.manufacturers && this.manufacturers.length < this.total) {
      this.fetchManufacturers();
    } else if (!this.total) {
      this.fetchManufacturers();
    }
  },
  computed: {
    ...mapGetters('manufacturer', { manufacturers: 'getAll' }),
    ...mapState({
      user: state => state.currentUser.currentUser,
      authenticated: state => state.currentUser.authenticated,
      heading: state => state.manufacturer.heading,
      description: state => state.manufacturer.description,
      status: state => state.manufacturer.status,
      nextUrl: state => state.manufacturer.nextUrl,
      displayStyle: state => state.manufacturer.displayStyle,
      sort: state => state.manufacturer.sort,
      total: state => state.manufacturer.total,
    }),
  },
  methods: {
    ...mapActions('manufacturer', ['FETCH_MORE']),
    updateItems() {
      this.FETCH_MORE();
    },
    removeItem({ slug }) {
      this.$store.dispatch('manufacturer/REMOVE', { slug })
    },
    url(slug) {
      return `/manufacturer/${slug}`
    },
    fetchManufacturers() {
      this.$store.dispatch('manufacturer/FETCH_ALL', {
        num
      });
    },
    toggleDisplayStyle({ display }) {
      this.$store.dispatch('manufacturer/CHANGE_DISPLAY_STYLE', { display })
    },
    toggleSort({ direction, field }) {
      this.$store.dispatch('manufacturer/SORT', { direction, field });
    },
    plural,
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/_config.scss';

.item-list {
  margin: 0;
  padding: 0;
}

.button-holder {
  text-align: left;
  padding-top: 0;
  
  .sort-button {
    margin-right: 10px;
    width: auto;
  }
}

</style>
